const API_BASE = '/api'

async function authFetch(path: string, options?: RequestInit): Promise<Response> {
  const res = await fetch(`${API_BASE}${path}`, { credentials: 'include', ...options })
  if (res.status === 401) {
    window.location.href = '/auth/login'
    throw new Error('Session expired')
  }
  return res
}

async function failFriendly(res: Response, fallback: string): Promise<never> {
  let msg = fallback
  try {
    const body = await res.json()
    if (body?.error && typeof body.error === 'string') msg = body.error
  } catch {
    void 0
  }
  throw new Error(msg)
}

export interface UserSkill {
  id: string
  skillKey: string
  title: string
  instructions: string
  status: string
  createdAt: string
  updatedAt: string
}

export async function fetchUserSkills(): Promise<UserSkill[]> {
  const res = await authFetch('/user/skills')
  if (!res.ok) await failFriendly(res, "Couldn't load skills.")
  const body: { skills: UserSkill[] } = await res.json()
  return body.skills
}

export async function saveUserSkill(body: { skillKey: string; title: string; instructions: string }): Promise<UserSkill> {
  const res = await authFetch('/user/skills', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })
  if (!res.ok) await failFriendly(res, "Couldn't save skill.")
  const data: { skill: UserSkill } = await res.json()
  return data.skill
}

export async function updateUserSkill(id: string, body: { skillKey: string; title: string; instructions: string }): Promise<UserSkill> {
  const res = await authFetch(`/user/skills/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })
  if (!res.ok) await failFriendly(res, "Couldn't update skill.")
  const data: { skill: UserSkill } = await res.json()
  return data.skill
}

export async function deleteUserSkill(id: string): Promise<void> {
  const res = await authFetch(`/user/skills/${encodeURIComponent(id)}`, { method: 'DELETE' })
  if (!res.ok) await failFriendly(res, "Couldn't delete skill.")
}
